import React from 'react';

function Grid(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <div className="grid" {...props} />;
}

export default Grid;
